var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M64 0H8C3.6 0 0 3.6 0 8V64C0 68.404 3.6 72 8 72H36V44H28V34.1H36V25.9C36 17.244 40.848 11.164 51.064 11.164L58.276 11.172V21.592H53.488C49.512 21.592 48 24.576 48 27.344V34.104H58.272L56 44H48V72H64C68.4 72 72 68.404 72 64V8C72 3.6 68.4 0 64 0Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"72","height":"72","viewBox":"0 0 72 72","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
